import React, { useContext } from "react";
import { Box, IconButton } from "@mui/material";
import { FaFacebookF, FaInstagram, FaYoutube, FaTiktok } from "react-icons/fa";
import { AuthContext } from "../../../context/authContext";

const RedesDiv = ({ iconColor = "#888" }) => {
  const { empresa = {} } = useContext(AuthContext);

  return (
    <Box>
      {empresa?.emp_facebook && (
        <IconButton
          href={empresa.emp_facebook.startsWith("http") ? empresa.emp_facebook : `https://${empresa.emp_facebook}`}
          target="_blank"
        >
          <FaFacebookF style={{ color: iconColor, fontSize: "24px" }} />
        </IconButton>
      )}

      {empresa?.emp_instagram && (
         <IconButton
         href={empresa.emp_instagram.startsWith("http") ? empresa.emp_instagram : `https://${empresa.emp_instagram}`}
         target="_blank"
       >
          <FaInstagram style={{ color: iconColor, fontSize: "24px" }} />
        </IconButton>
      )}
      {empresa?.emp_youtube && (
         <IconButton
         href={empresa.emp_youtube.startsWith("http") ? empresa.emp_youtube : `https://${empresa.emp_youtube}`}
         target="_blank"
       >
          <FaYoutube style={{ color: iconColor, fontSize: "24px" }} />
        </IconButton>
      )}
      {empresa?.emp_tiktok && (
         <IconButton
         href={empresa.emp_tiktok.startsWith("http") ? empresa.emp_tiktok : `https://${empresa.emp_tiktok}`}
         target="_blank"
       >
          <FaTiktok style={{ color: iconColor, fontSize: "24px" }} />
        </IconButton>
      )}
    </Box>
  );
};

export default RedesDiv;
